import { DocusealForm } from "@docuseal/vue";

export default {
    name: "DocumentSubmission",
    components: {
        DocusealForm
    },
    props: {
        selected_template: {
            type: Object,
            default: null
        },
        configured_signers: {
            type: Object,
            default: null
        },
        populated_preview_url: {
            type: String,
            default: ""
        },
        populated_preview_external_url: {
            type: String,
            default: ""
        },
        populated_preview_form_src: {
            type: String,
            default: ""
        },
        populated_preview_token: {
            type: String,
            default: ""
        },
        populated_preview_loading: {
            type: Boolean,
            default: false
        },
        populated_preview_error: {
            type: String,
            default: ""
        }
    },
    computed: {
        selected_document_name() {
            return this.selected_template?.name || "";
        },
        selected_document_url() {
            return this.selected_template?.presigned_url || this.selected_template?.url || "";
        },
        selected_document_type() {
            return this.selected_template?.type
                ? String(this.selected_template.type).toUpperCase()
                : "PDF";
        },
        can_render_docuseal_preview() {
            return Boolean(String(this.populated_preview_form_src || "").trim());
        },
        review_document_url() {
            return String(this.populated_preview_url || "").trim();
        },
        preview_launch_url() {
            return String(this.populated_preview_external_url || "").trim() || this.review_document_url || this.selected_document_url;
        },
        has_populated_preview() {
            return Boolean(String(this.populated_preview_url || "").trim());
        },
        signer_summary() {
            return this.configured_signers || {};
        },
        configured_signer_list() {
            return Array.isArray(this.signer_summary?.signers) ? this.signer_summary.signers : [];
        },
        notification_copy() {
            return this.signer_summary?.signing_mode === "parallel"
                ? "Email notifications will go to all signers together with a secure link to review and sign this document."
                : "Email notifications will go to each signer with a secure link to review and sign this document.";
        },
        preview_state_copy() {
            if (this.populated_preview_loading) {
                return "Preparing the populated document preview...";
            }

            if (this.can_render_docuseal_preview) {
                return "This preview shows the populated document that will be sent for signing.";
            }

            if (this.has_populated_preview) {
                return "This preview shows the populated document that will be sent for signing.";
            }

            if (this.populated_preview_error) {
                return this.populated_preview_error;
            }

            if (this.preview_launch_url) {
                return "The populated document is available to open, but an inline preview URL was not returned.";
            }

            return "The selected template does not include a populated preview yet.";
        }
    },
    methods: {
        open_review_document() {
            if (!this.preview_launch_url || typeof window === "undefined") {
                return;
            }

            window.open(this.preview_launch_url, "_blank", "noopener,noreferrer");
        }
    }
};
